import * as Yup from 'yup';
export const validationSchema = Yup.object().shape({
      Disease: Yup.string()
      .matches(/^[A-Za-z\s]+$/, 'Disease should only contain letters')
      .required('Disease is required'),
      Date: Yup.date().required("Date is required"),
  });